import { render, staticRenderFns } from "./batchDialog.vue?vue&type=template&id=6f41448a&scoped=true"
import script from "./batchDialog.vue?vue&type=script&lang=js"
export * from "./batchDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f41448a",
  null
  
)

export default component.exports